define("shared/helpers/css-safe", ["exports", "@ember/component/helper"], function (_exports, _helper) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper"eaimeta@70e063a35619d71f
  const cssSafeHelper = (0, _helper.helper)((params /*, hash*/) => params[0]?.replace(/\W/g, '') || '');
  var _default = _exports.default = cssSafeHelper;
});